import React, { 
    useState,
     useEffect, 
     useContext,
    } from 'react';
  import { Field, Form } from 'react-final-form';
  import { Col } from 'react-bootstrap';
  import {
    Card, CardBody, CardTitleWrap,
  } from '@/shared/components/Card';
  import { renderMaskedField } from '@/shared/components/form/FormField';
  import {
      FormButtonToolbar,
      FormContainer,
      FormGroup,
      FormGroupField,
      FormGroupLabel,
      FormHalfContainer,
    } from '@/shared/components/form/FormElements';
    import Select from 'react-select';
    import { Button } from '@/shared/components/Button';
    import PropTypes from 'prop-types';
    import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
    import { AuthContext } from '../../../../../context/AuthContext';
  
    const AddUser = ({ onSubmit, restaurantid, loading }) => {
    const { apiGlobal } = useContext(GlobalVarContext);
    const { countryId } = useContext(AuthContext);
    const [fetchLocationName, setFetchLocationName] = useState([]);
     const [country, setCountry] = useState([]);

    useEffect(() => {
          const fetchRestaurantData = async () => {
            if (!restaurantid) {
              console.error('No restaurant selected. Please provide a valid restaurant ID.');
              return;
            }
              const formData = new FormData();
              formData.append('type', 2);
              formData.append('id', restaurantid);
              formData.append('country_id', countryId);
            try {
              const response = await fetch(`${apiGlobal}/restaurant_data_load.php`, {
                method: 'POST',
                body: formData,
              });
              const data = await response.json();
              // console.log(data);
      
              if (data?.status && data?.message === 'Success') {
                const locationNames = data?.data.map(item => ({
                  value: item?.id,
                  label: item?.restaurant_name,
                }));
                setFetchLocationName(locationNames);
              } else {
                console.error('API responded with an error:', data?.message || 'Unknown error');
              }
            } catch (error) {
              console.error('Error fetching restaurant data:', error.message);
            }
          };
      
          fetchRestaurantData();
        }, [restaurantid]); 

        const fetchCountryList = async () => {
      try {
        const url = await fetch(`${apiGlobal}/currency_master_list.php`, {
            method: 'POST',
          });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          setCountry(response?.data);
        } else {
          setCountry([]);
        }
      } catch (error) {
        console.log(error);
      } 
    };
  
    useEffect(() => {
      fetchCountryList();
    }, []);

        // console.log(fetchLocationName);
   
    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <CardTitleWrap>
              <p><span style={{ color: 'red' }}>*</span> Mark Fields are required.</p>
            </CardTitleWrap>
            <Form onSubmit={onSubmit}>
              {({ handleSubmit, form }) => (
                <FormContainer onSubmit={handleSubmit}>
                  <FormHalfContainer>
                    <FormGroup>
                      <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="name"
                          component="input"
                          type="text"
                          placeholder="Enter Name"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>User Name (Email) <span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="username"
                          component="input"
                          type="email"
                          placeholder="Enter UserName/ Email"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>Mobile No 1<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
                          {/* Country Code Select */}
                          <Field
                            name="countryCode"
                            render={({ input, meta }) => (
                              <div>
                                <Select
                                  {...input}
                                  options={country.map(item => ({
                                  value: item.id,
                                  label: item.country_code,
                                }))}
                                    // isLoading={isLoading}
                                  placeholder="Code"
                                  classNamePrefix="react-select"
                                  components={{
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null,
                                }}
                                  styles={{
                                  control: provided => ({
                                    ...provided,
                                    width: '70px',
                                    height: '45px',
                                    // borderRadius: '5px',
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    width: '70px',
                                    zIndex: 9999,
                                  }),
                                  option: provided => ({
                                    ...provided,
                                    width: '70px',
                                  }),
                                }}
                                />
                                {meta.touched && meta.error && (
                                  <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                  )}
                              </div>
                            )}
                          />

                          {/* Phone Input */}
                          <Field
                            name="mobile1"
                            render={({ input, meta }) => (
                              <div style={{ flex: 1 }}>
                                <input
                                  {...input}
                                  type="text"
                                  inputMode="numeric"
                                    // pattern="\d{12}"
                                  maxLength={12}
                                  placeholder="Enter Phone Number"
                                  style={{
                                  width: '100%',
                                  height: '45px',
                                  padding: '10px',
                                  // borderRadius: '5px',
                                  // border: '1px solid gray',
                                }}
                                  onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                  input.onChange(e.target.value);
                                }}
                                />
                                {meta.touched && meta.error && (
                                  <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                              )}
                              </div>
                            )}
                          />
                        </div>
                        {/* <Field name="country_code_id">
                          {({ input, meta }) => (
                            <div>
                              <select
                                {...input}
                                style={{
                              height: '45px',
                              backgroundColor: 'white',
                              border: '1px solid gray',
                              width: '100%',
                              borderRadius: '5px',
                              paddingLeft: '10px',
                            }}
                                required
                              >
                                <option value="">Select Country Code</option>
                                {country.map(nation => (
                                  <option key={nation.id} value={nation.id}>
                                    {nation.country_code}
                                  </option>
                                                      ))}
                              </select>
                              {meta.touched && meta.error && (
                                <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                                                    )}
                            </div>
                                                  )}
                        </Field>
                        <Field
                          name="mobile1"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          pattern="\d{1,12}"
                          maxLength={12} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                          }}
                          placeholder="Enter Mobile 1"
                          required
                          style={{ height: '45px' }}
                          
                        /> */}
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>Select Allowed Location<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <Field
                        name="locationsid"
                        render={({ input, meta }) => (
                          <Select
                            {...input} 
                            name="locationsid"
                            className="react-select"
                            classNamePrefix="react-select"
                            isMulti
                            options={fetchLocationName}
                            isClearable
                            placeholder="Select a Location" 
                          />
                      )}
                        required
                      />
                    </FormGroup>
                  </FormHalfContainer>
                  <FormHalfContainer>
                    <FormGroup>
                      <FormGroupLabel>Designation<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="designation"
                          component="input"
                          type="text"
                          placeholder="Enter Degisnation"
                          required
                          style={{ height: '45px' }}
                          
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>Password<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="password"
                          component="input"
                          type="text"
                          placeholder="Enter Password"
                          required
                          style={{ height: '45px' }}
                          
                        />
                      </FormGroupField>
                    </FormGroup>
                    <FormGroup>
                      <FormGroupLabel>WhatsApp No<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="mobile2"
                          component="input"
                          type="number"
                          inputMode="numeric" // mobile-friendly numeric keyboard
                          // pattern="\d{1,12}"
                          maxLength={12} // limit to 15 digits
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                          }}
                          placeholder="Enter WhatsApp no"
                          required
                          style={{ height: '45px' }}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </FormHalfContainer>
                  <FormButtonToolbar>
                    <Button variant="primary" type="submit" disabled={loading}>Submit</Button>
                  </FormButtonToolbar>
                </FormContainer>
              )}
            </Form>
          </CardBody>
        </Card>
      </Col>
      
    );
  };

  AddUser.propTypes = {
      onSubmit: PropTypes.func.isRequired,
      restaurantid: PropTypes.string.isRequired,
      loading: PropTypes.bool.isRequired,
    };

  export default AddUser;

